export const isLastItemOfArray = (length: number, index: number) => length - 1 === index;
export const hasArrayElements = (array: unknown[]) => array.length > 0;
